
export default function Testimonials() {
  const testimonials = [
    {
      name: "Sarah M.",
      treatment: "Single Tooth Implant",
      rating: 5,
      text: "I was terrified of the dentist but Dr. Yasir made me feel at ease from the very first appointment. My implant looks so natural and the whole process was painless.",
      image: "https://public.readdy.ai/ai/img_res/dc5bcd6b422a3730d861e4cbc2c35fb0.jpg"
    },
    {
      name: "John P.",
      treatment: "All-on-4 Implants",
      rating: 5,
      text: "The team at Beaulieu Dental are incredible. Professional, caring and so reassuring. My implants feel like real teeth again!",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20happy%20smiling%20man%20in%20his%20fifties%20with%20natural%20confident%20smile%20showing%20perfect%20white%20teeth%20in%20bright%20modern%20setting&width=200&height=200&seq=test002&orientation=squarish"
    },
    {
      name: "Emma L.",
      treatment: "Multiple Implants",
      rating: 5,
      text: "I was nervous about surgery but Dr. Saeed explained everything clearly and I felt completely comfortable. My confidence is back thanks to my new smile.",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20happy%20smiling%20woman%20in%20her%20thirties%20with%20natural%20confident%20smile%20showing%20perfect%20white%20teeth%20in%20bright%20modern%20setting&width=200&height=200&seq=test003&orientation=squarish"
    },
    {
      name: "David R.",
      treatment: "Implant-Supported Dentures",
      rating: 5,
      text: "From start to finish, absolutely amazing care. Highly recommend Dr. Saeed for anyone considering implants.",
      image: "https://readdy.ai/api/search-image?query=professional%20portrait%20of%20happy%20smiling%20man%20in%20his%20sixties%20with%20natural%20confident%20smile%20showing%20perfect%20white%20teeth%20in%20bright%20modern%20setting&width=200&height=200&seq=test004&orientation=squarish"
    }
  ];

  return (
    <section id="testimonials" className="py-20 bg-[#444c42] relative overflow-hidden">
      {/* Wave Divider Top */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-none">
        <svg className="relative block w-full h-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#ffffff"></path>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            GOOGLE REVIEW HIGHLIGHTS<br />(Implant Patients)
          </h2>
          <p className="text-lg text-white/90 max-w-3xl mx-auto">
            Real experiences from our dental implant patients
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {testimonials.map((testimonial, index) => (
            <div key={index} className="bg-white p-8 rounded-2xl shadow-xl">
              <div className="flex items-center gap-4 mb-6">
                <div className="w-16 h-16 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={testimonial.image}
                    alt={testimonial.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <h3 className="text-xl font-bold text-[#444c42]">{testimonial.name}</h3>
                  <p className="text-sm text-[#7A8178]">{testimonial.treatment}</p>
                </div>
              </div>
              <div className="flex gap-1 mb-4">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#D0A24F] text-xl"></i>
                ))}
              </div>
              <p className="text-base text-[#7A8178] leading-relaxed">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>

        <div className="text-center">
          <a
            href="https://www.google.com/maps/place/Beaulieu+Dental/@51.7598302,0.4994672,17z/data=!4m16!1m9!3m8!1s0x47d8e9361f3a520f:0xff99227fe78d18b4!2sBeaulieu+Dental!8m2!3d51.7598302!4d0.4994672!9m1!1b1!16s%2Fg%2F11gfctc96j!3m5!1s0x47d8e9361f3a520f:0xff99227fe78d18b4!8m2!3d51.7598302!4d0.4994672!16s%2Fg%2F11gfctc96j?entry=ttu&g_ep=EgoyMDI1MTIwMi4wIKXMDSoASAFQAw%3D%3D"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#D0A24F] text-white px-8 py-4 rounded-lg text-base font-semibold hover:bg-[#F5d383] transition-all transform hover:scale-105 shadow-lg whitespace-nowrap cursor-pointer"
          >
            Read More Reviews on Google
          </a>
        </div>
      </div>

      {/* Wave Divider Bottom */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none rotate-180">
        <svg className="relative block w-full h-16" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#ffffff"></path>
        </svg>
      </div>
    </section>
  );
}
